import axios from 'axios';
import AuthService from './auth'
import UsuarioService from './usuario';
import LoginService from './login';
import ColaboradoresService from './colaborador';
import ProdutoService from './produtos';
import VendasService from './vendas';
import configuracaoService from './configuracao';
import UsuarioMLService from './usuariosMercadoLivre'
import DashboardService from './dashboard';
import TarefasService from './tarefas';
import HorariosService from './horarios';
import PontuacaoService from './pontuacoes';

const API_ENVS = {
  production: '',
  development: '',
  //  local:'http://192.168.3.102:8000/api/'
  local: 'https://backdemode.centrion.com.br/api/'
}
const httpClient = axios.create({
  baseURL: API_ENVS.local
})
export default {
  devServer: {
    proxy: 'http://192.168.3.12:8888/api/'
  },
  auth: AuthService(httpClient),//OK
  login: LoginService(httpClient),//OK
  usuario: UsuarioService(httpClient),//OK
  colaboradores: ColaboradoresService(httpClient),
  vendas: VendasService(httpClient),
  produtos: ProdutoService(httpClient),
  configuracao: configuracaoService(httpClient),
  dashboard: DashboardService(httpClient),
  usuarioMercadoLivre: UsuarioMLService(httpClient),
  tarefas: TarefasService(httpClient),
  horarios: HorariosService(httpClient),
  pontuacoes: PontuacaoService(httpClient),
}